import { IHallBookingBill } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
	update: {
		billNo?: string
		date?: number
		electricity?: {
			previousReading: number
			currentReading: number
			amount: number
		}
		gas?: {
			previousReading: number
			currentReading: number
			amount: number
		}
	}
}

export async function hallBookingBillUpdateApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/hall/booking/bill/update/v1"
	const requester = new ApiRequester<RequestDataShape, IHallBookingBill>(endpoint)
	return await requester.sendRequest(payload, token)
}
